export { default } from './IconLegacyInformation';
